import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Tabs, Tooltip } from 'tdesign-react';
import SvgIcon from '@/components/SvgIcon';
import ShadowCard from '@/components/ShadowCard';
import LinkClusterModal from '@/pages/Cluster/ClusterList/LinkClusterModal';
import PermWrapper from '@/components/PermWrapper';
import { doBuried } from '@/services/buriedService';
import ClusterBadgeTag from '../../components/ClusterBadgeTag';
import InfoPanel from './InfoPanel';
// import HistoryPanel from './HistoryPanel';
import GeoPanel from './GeoPanel';
import RecoverInfo from './RecoverInfo';
import bgPng from './bg.png';

const backupServerColor = '#3361ff';

const { TabPanel } = Tabs;

function BasicInfo({ detail, doRefresh }) {
  const [visible, setVisible] = useState(false);

  const handleClose = (refresh) => {
    setVisible(false);
    if (refresh) {
      doRefresh();
    }
  };

  return (
    <Root $isBackupServer={detail.isDisasterRecoveryCluster}>
      <Header>
        <Title>
          {detail.displayName}
          <PermWrapper resource='pulsar:cluster:update'>
            <Icon onClick={() => setVisible(true)} type='pencil-alt' />
          </PermWrapper>
        </Title>
        <RecoverInfo currentCluster={detail} />
      </Header>
      <Tabs
        addable={false}
        defaultValue='CLUSTER_DETAIL'
        dragSort={false}
        placement='top'
        size='medium'
        theme='normal'
        onChange={(val) => doBuried({ eventId: val })} // 埋点
      >
        <TabPanel destroyOnHide label='基本信息' removable={false} value='CLUSTER_DETAIL'>
          <InfoPanel />
        </TabPanel>
        <TabPanel destroyOnHide label='GEO配置' removable={false} value='CLUSTER_GEO'>
          <GeoPanel />
        </TabPanel>
      </Tabs>
      <LinkClusterModal
        visible={visible}
        handleClose={handleClose}
        clusterName={detail.clusterName}
      />
      {detail.isDisasterRecoveryCluster && <Bg src={bgPng} />}
      {detail.isDisasterRecoveryCluster && (
        <ClusterBadgeTag color={backupServerColor} size='small'>
          <Tooltip
            placement='left'
            content='备集群通常用于提供高可用性、容错性和数据备份等功能，以应对故障和灾难的场景。通常建议该集群单一职责，不与业务场景混用。'
          >
            备
          </Tooltip>
        </ClusterBadgeTag>
      )}
    </Root>
  );
}

export default connect((state) => ({
  detail: state.cluster.detail,
}))(BasicInfo);

const Root = styled(ShadowCard)`
  padding-bottom: 10px;
  position: relative;
  overflow: hidden;
  .t-tabs {
    background-color: transparent;
  }
  ${(props) =>
    props.$isBackupServer &&
    `
      background: rgb(249 250 255);
  `}
`;

const Bg = styled.img`
  position: absolute;
  width: 340px;
  height: 284px;
  right: -40px;
  bottom: -74px;
  pointer-events: none;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 20px;
  color: #0d111a;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

const Icon = styled(SvgIcon)`
  margin-left: 8px;
  color: var(--td-font-gray-2);
  cursor: pointer;
`;
